import { ReactNode, useMemo } from "react";
import { motion } from "framer-motion";
import SectionQr from '../components/SectionQr';
import { NIKE_EASE } from '../../../../rise/constants/nikerise';
import Media from './Media';
import { QR_DURATION_S, STATIC_STATE_DELAY_S } from '../PosterChapter.constants';
import ServiceHubPosterChapterData from '../PosterChapter.interface';
import { get } from 'lodash';

interface VariantWrapperProps {
    children: ReactNode,
    data: ServiceHubPosterChapterData,
}

function VariantWrapper(props: VariantWrapperProps) {
    const { children, data } = props;

    const qrDelay = useMemo(() => {
        if (data?.media?.resource_type === 'image') {
            return STATIC_STATE_DELAY_S;
        } else {
            const mediaDuration = get(data, 'media.duration', STATIC_STATE_DELAY_S);

            return Math.max(mediaDuration - QR_DURATION_S, 0);
        }
    }, [data?.media]);

    return (
        <motion.div
            style={{
                position: 'relative',
                width: '100vw',
                height: '100vh'
            }}
            transition={{
                duration: 1.5,
                ease: NIKE_EASE,
            }}
            exit={{
                y: `-100vh`,
                transition: {
                    ease: NIKE_EASE,
                    duration: 1.5,
                },
            }}
        >
            {children}

            <Media style={{ position: 'absolute', zIndex: -10, }} media={data?.media} toApplyInternalEffect={false} />

            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: -9,
                    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)'
                }}
            />

            {data?.has_qr_code ? (
                <SectionQr
                    media={data?.qr_code?.media}
                    title={data?.qr_code?.title}
                    subtitle={data?.qr_code?.subtitle}
                    delay={qrDelay}
                />
            ) : null}
        </motion.div>
    )
}

export default VariantWrapper;
